import React from 'react';
import { useTranslate } from '@tolgee/react';

import { Tag } from './Tag';

export interface RequestTypeTagProps {
  requestType: 'assign' | 'remove' | 'revoke';
  className?: string;
}

export function RequestTypeTag({
  requestType,
  className
}: RequestTypeTagProps) {
  const { t } = useTranslate();

  const text =
    requestType === 'assign'
      ? t('report.requestTypes.assign', 'Assign')
      : requestType === 'revoke'
      ? t('report.requestTypes.revoke', 'Revoke')
      : t('report.requestTypes.remove', 'Remove');

  return (
    <Tag
      text={text}
      backgroundColor="#191F2E14"
      textColor="default"
      className={className}
    />
  );
}
